import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useForm } from "react-hook-form";
import Paper from "@mui/material/Paper";
import BorderColorOutlinedIcon from "@material-ui/icons/BorderColorOutlined";
import "../components/Table/Table.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import TopLoader from "../components/Loader/TopLoader";
import {
  allChecklist,
  checklist_inactive,
  class_api,
  section_api,
  subject_api,  
} from "../api/Users";
import { toast } from "react-toastify";
import { TextField, TablePagination, Tooltip, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Modal, Button, Typography } from "@mui/material";
import { MDBTypography } from "mdb-react-ui-kit";
import adhaarImg from "../images/adhaar.png";
import { Image } from "react-bootstrap";
import Box from "@mui/material/Box";
import axios from "../api/constant";

const Assignments = ({ role, mainId, userData }) => {
  const [error, setErrors] = useState({});

  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(true);
  const [rows, setRows] = useState([]);

  // Search and pagination
  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const location = useLocation();
  const rowData = location.state;
  const [assignment, setAssignment] = useState({
    assignment_name: "",
    assignment_name: "",
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const openModal = () => {
    setIsModalOpen(true);
  };
  const [photo, setPhoto] = useState(null);
  const [isClass, setClass] = useState([]);
  const [isSection, setSection] = useState([]);
  const [isSubject, setSubject] = useState([]);

  useEffect(() => {
    handleClass();
  }, [userData]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  let navigate = useNavigate();
  const view = (row) => {
    navigate(`/add-assignment`, { state: row });
  };

  //   const view1 = (rowId) => {
  //     navigate(`/update-assignment/${rowId}`);
  //   };
  const view1 = () => {
    navigate(`/update-assignment`);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleImageClick = (imageData) => {
    var w = window.open("about:blank");
    setTimeout(() => {
      w.document.body.appendChild(w.document.createElement("iframe")).src =
        "data:image/png;base64," + imageData;
      w.document.body.style.margin = 0;
      w.document.getElementsByTagName("iframe")[0].style.width = "100%";
      w.document.getElementsByTagName("iframe")[0].style.height = "100%";
      w.document.getElementsByTagName("iframe")[0].style.border = 0;
    }, 0);
  };
  const handleSection = (e) => {
    setIsLoading(true);
    let data = {
      class_id: e.target.value,
    };
    section_api(data)
      .then((res) => {
        if (res.status === "success" && res.data && res.data.section_data) {
          setIsLoading(false);
          setSection(res.data.section_data);
        } else {
          toast.error(t("Section data not found"));
        }
      })
      .catch((error) => {
        toast.error(t("Something went wrong"));
      });

      subject_api(data)
      .then((res) => {
        if (res.status === "success" && res.data && res.data.subject_data) {
          setSubject(res.data.subject_data);
        } else {
          toast.error(t("Subject data not found"));
        }
      })
      .catch((error) => {
        toast.error(t("Something went wrong"));
      })
  };

  const handleClass = () => {
    if (!userData || !userData.data || !userData.data.school_id) {
      toast.error(t("User data is not available"));
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    let data = {
      school_id: userData.data.school_id,
    };
    class_api(data)
      .then((res) => {
        if (res.status === "success" && res.data && res.data.class_data) {
          setClass(res.data.class_data);
        } else {
          toast.error(t("Class data not found"));
        }
      })
      .catch((error) => {
        toast.error(t("Something went wrong"));
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  const handleChangeInput = (e) => {
    const { name, value, type, files } = e.target;
    console.log("Name:", name);
    console.log("Value:", value);

    if (type !== "file") {
      setAssignment((prevAssignment) => ({ ...prevAssignment, [name]: value }));
    } else {
      const file = files[0];
      setAssignment((prevAssignment) => ({ ...prevAssignment, [name]: file }));
    }

    if (
      name === "class" &&
      userData &&
      userData.data &&
      userData.data.school_id
    ) {
      handleSection({ class: value });
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();

    const formErrors = {};

    if (photo === null) {
      formErrors.assignment_photo = "No assignment photo selected!";
    }

    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      setIsLoading(true);
      const formData = new FormData();

      // Append each field and its value to the FormData object
      for (const key in assignment) {
        formData.append(key, assignment[key]);
      }
      formData.append("assignment_photo", photo);

      // Send a request to update the assignment
      axios
        .put(`/update-assignment/${assignment.id}`, formData)
        .then((res) => {
          if (res.status === "success") {
            setIsLoading(false);
            toast.success(t(res.message));
            navigate("/assignment-list"); // Redirect to assignment list page after successful update
          } else {
            toast.error(t(res.message));
          }
        })
        .catch((err) => {
          console.error(err);
          toast.error("An error occurred while updating the assignment.");
        });
    }
  };
  const handlePhotoChange = (event) => {
    const file = event.target.files[0];
    if (!file) {
      toast.error("No assignment document selected!.");
      return;
    }

    const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.pdf)$/i;

    if (!allowedExtensions.test(file.name)) {
      toast.error(
        "Invalid file type. Only JPG, PNG and PDF files are allowed."
      );
      event.target.value = "";
      return;
    }
    setPhoto(file);
  };

  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="row col-12 d-flex justify-content-center mt-4 bg-white">
        {/* <div className="construction"></div> */}
      </div>
      <div className="px-0 px-md-3">
        <div className="mb-4 col-12 d-flex justify-content-between align-items-center">
          <h5 className="">{t("All Assignments")}</h5>
          <div>
            <button className="btn btn-primary btn-sm" onClick={() => view()}>
              <AddIcon />
              {t("Add Assignment")}
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <label className="form-label">
              {t("Class")}
              {<span style={{ color: "red" }}>*</span>}
            </label>
            <select
              name="class"
              onChange={handleSection}
              value={assignment.class}
              className="form-control"
              placeholder="Select Class"
              required
            >
              <option value="">Select Class</option>
              {isClass.map((classItem) => (
                <option key={classItem.class_id} value={classItem.class_id}>
                  {classItem.class}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-4">
            <label className="form-label">
              {t("Section")}
              {<span style={{ color: "red" }}>*</span>}
            </label>
            <select
              name="section"
              onChange={handleChangeInput}
              className="common-input form-select"
              // required
            >
              <option value="">Select Section</option>
              {isSection.map((classItem) => (
                <option key={classItem.section_id} value={classItem.section_id}>
                  {classItem.section}
                </option>
              ))}
            </select>
            {error.section && (
              <div className="text-danger">{error.section}</div>
            )}
          </div>
          <div className="col-md-4">
            <label className="form-label">
              {t("Subject")} {<span style={{ color: "red" }}>*</span>}
            </label>
            <select
              name="subject"
              onChange={handleChangeInput}
              className="common-input form-select"
              // required
            >
              <option value="">Select Subject</option>
              {isSubject.map((classItem) => (
                <option key={classItem.subject_id} value={classItem.subject_id}>
                  {classItem.subject}
                </option>
              ))}
            </select>
            {error.subject && (
              <div className="text-danger">{error.subject}</div>
            )}
          </div>
        </div>
        <div className="Table mb-6">
          <TableContainer
            component={Paper}
            style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
            className="my-4"
          >
            <Table sx={{ minWidth: 800 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>{t("Sr. No.")}</TableCell>
                  <TableCell align="center">{t("Title")}</TableCell>
                  <TableCell align="center">{t("Date of Assignment")}</TableCell>
                  <TableCell align="center">{t("Last Date of Submission")}</TableCell>
                  <TableCell align="center">{t("Document")}</TableCell>
                  <TableCell align="center">{t("Action")}</TableCell>
                </TableRow>
              </TableHead>
              {/* {!isLoading && filteredData && filteredData.length > 0 && (
                  <TableBody style={{ color: "white" }}>
                    {filteredData
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((row, index) => (
                        <TableRow key={index}>
                          <TableCell component="th" scope="row">
                            {index + 1}
                          </TableCell>
                          <TableCell align="center" style={{ width: "15%" }}>
                            {row.additionalData.name || "English Assignment"}
                          </TableCell>
                          <TableCell align="center">{row.additionalData.posted_at}</TableCell>
                          <TableCell align="center">
                          <Tooltip title="Add Question">
                              <IconButton onClick={() => view1(row.additionalData.id)}>
                                <BorderColorOutlinedIcon />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                )} */}

              <TableBody>
                <TableRow>
                  <TableCell>1</TableCell>
                  <TableCell align="center" style={{ width: "15%" }}>
                    English Assignment
                  </TableCell>
                  <TableCell align="center">12/02/2023</TableCell>
                  <TableCell align="center">19/02/2023</TableCell>
                  <TableCell align="center">File</TableCell>
                  <TableCell align="center">
                    <Tooltip title="Edit Assignment">
                      <IconButton onClick={() => openModal()}>
                        <BorderColorOutlinedIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              </TableBody>

              {!isLoading && (!filteredData || filteredData.length === 0) && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={7}>
                      <h4>
                        <i>No data available</i>
                      </h4>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>
      <Modal
        open={isModalOpen}
        onClose={closeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            width: "fitContent",
            bgcolor: "background.paper",
            borderRadius: "10px",
            boxShadow: 24,
            p: 4,
          }}
        >
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={closeModal}
            style={{
              position: "absolute",
              top: 10,
              right: 10,
              background: "none",
              border: "none",
              fontSize: 24,
              cursor: "pointer",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              className="bi bi-x"
              viewBox="0 0 16 16"
            >
              <path d="M3.854 3.146a.5.5 0 0 1 .708 0L8 7.293l3.646-3.647a.5.5 0 1 1 .708.708L8.707 8l3.647 3.646a.5.5 0 1 1-.708.708L8 8.707l-3.646 3.647a.5.5 0 1 1-.708-.708L7.293 8 3.646 4.354a.5.5 0 0 1 0-.708z" />
            </svg>
          </button>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {t("Edit Assignment")}
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <div className="px-2 px-md-4">
              {/* <div className="my-4 col-12 d-flex justify-content-between align-items-center">
                <h5 className="">{t("Edit Assignment")}</h5>
              </div> */}

              <form
                onSubmit={(e) => onSubmit(e)}
                id="myform"
                style={{ marginTop: "12px" }}
              >
                <div className="row">
                  {/* <div className="col-md-4">
              <label className="form-label">
                {t("Photo")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="file"
                name="assignment_photo"
                accept=".jpg, .jpeg, .png"
                className="form-control"
                onChange={handlePhotoChange}
              />
              {error.assignment_photo && (
                <div className="text-danger">{error.assignment_photo}</div>
              )}
            </div> */}
                  <div className="col-md-4 ">
                    <label className="form-label">
                      {t("Upload Document")}{" "}
                      {<span style={{ color: "red" }}>*</span>}
                    </label>
                    <input
                      type="file"
                      name="assignment_photo"
                      accept=".jpg, .jpeg, .png, .pdf"
                      className="form-control"
                      onChange={handlePhotoChange}
                    />
                    {error.assignment_photo && (
                      <div className="text-danger">
                        {error.assignment_photo}
                      </div>
                    )}
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">
                      {t("Class")}
                      {<span style={{ color: "red" }}>*</span>}
                    </label>
                    <select
                      name="class"
                      onChange={handleChangeInput}
                      className="common-input form-select"
                      // required
                    >
                      <option value="">Select class</option>
                      <option value="">I</option>
                      <option value="">II</option>
                      <option value="">III</option>
                      <option value="">IV</option>
                      <option value="">V</option>
                      <option value="">VI</option>
                      <option value="">VII</option>
                      <option value="">VIII</option>
                      <option value="">IX</option>
                      <option value="">X</option>
                      <option value="">XI</option>
                      <option value="">XII</option>
                    </select>
                    {error.isClass && (
                      <div className="text-danger">{error.isClass}</div>
                    )}
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">
                      {t("Subject Name")}
                      {<span style={{ color: "red" }}>*</span>}
                    </label>
                    <select
                      name="subject_name"
                      onChange={handleChangeInput}
                      className="common-input form-select"
                      // required
                    >
                      <option value="">Select Subject</option>
                    </select>
                    {error.subject && (
                      <div className="text-danger">{error.subject}</div>
                    )}
                  </div>
                  <div className="col-md-4 mt-4">
                    <label className="form-label">
                      {t("Last Date of Submission")}{" "}
                      {<span style={{ color: "red" }}>*</span>}
                    </label>
                    <input
                      type="date"
                      name="from_data"
                      className="form-control"
                      onChange={handleChangeInput}
                      // required
                    />
                    {error.from_data && (
                      <div className="text-danger">{error.from_data}</div>
                    )}
                  </div>

                  <div
                    className="col-md-4 mt-4"
                    style={{ display: "flex", alignItems: "end" }}
                  >
                    <button
                      type="submit"
                      className="btn btn-primary me-2 col-md-4"
                    >
                      {t("Save")}
                    </button>

                    <button
                      type="reset"
                      className="btn btn-secondary me-2 col-md-4"
                    >
                      {t("Reset")}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </Typography>

          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <Button color="secondary" onClick={closeModal}>
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default Assignments;
